import Link from 'next-translate-routes/link';
import type { FC } from 'react';

import { cn } from '@/utils';

import { MainTitle } from '../MainTitle';

interface Action {
  title: string;
  url: string;
}
interface ActionBlockProps {
  title: string;
  image: string;
  description?: string;
  action: Action;
  className?: string;
}
export const ActionBlock: FC<ActionBlockProps> = ({
  image,
  title,
  description,
  action,
  className,
}) => {
  return (
    <div className={cn(className, 'w-full md:px-4')}>
      <div className="relative flex w-full flex-col items-center overflow-hidden bg-blue-900 px-[30px] pb-16 pt-[46px] md:gap-0 md:rounded-2xl md:pb-[96px] md:pt-[46px] lg:pb-[128px] lg:pt-[78px]">
        <div className="px-5 pb-4 pt-[18px] md:pb-[19px]">
          <picture>
            <source srcSet={image} type="image/png" />
            <img
              src={image}
              alt="letter"
              className="h-32 w-32"
              width={128}
              height={128}
            />
          </picture>
        </div>
        <MainTitle
          title={title}
          className="text-grey-50 md:max-w-[604px] md:text-[32px] md:tracking-[0.1px] lg:text-[40px] lg:leading-[48px] lg:tracking-[-0.64px]"
        />

        {description && (
          <div className="body1 mx-auto mt-4 max-w-xl text-center tracking-[0.1px] text-grey-100 md:mt-[14px]">
            {description}
          </div>
        )}
        <Link
          href={action.url}
          className="btn-blue-states body2-bold mt-8 rounded-full bg-blue-500 px-8 py-[21px] text-center text-[15px] tracking-[0.2px] text-white md:w-[240px] lg:mt-12"
        >
          {action.title}
        </Link>
      </div>
    </div>
  );
};
